import Vue from 'vue';
import { Validator } from 'cube-ui';

import {
  isMoney, isEmail, isPhone, isIdCardNo,
  isUscc, isBusLicen, isOrgCode } from './validate';

Vue.use(Validator);

Validator.addType('email', val => typeof val === 'string' && isEmail(val));

Validator.addType('money', val => typeof val === 'number' && isMoney(val.toString()));
Validator.addMessage('type', { money: '请输入有效金额' });

Validator.addType('mobile', val => typeof val === 'string' && isPhone(val));
Validator.addMessage('type', { mobile: '请输入有效手机号码' });

Validator.addType('idcardno', val => typeof val === 'string' && isIdCardNo(val));
Validator.addMessage('type', { idcardno: '请输入有效身份证号' });

Validator.addType('uscc', val => typeof val === 'string' && isUscc(val));
Validator.addMessage('type', { uscc: '请输入有效统一社会信用代码' });

Validator.addType('buslicen', val => typeof val === 'string' && isBusLicen(val));
Validator.addMessage('type', { buslicen: '请输入有效营业执照号' });

Validator.addType('orgcode', val => typeof val === 'string' && isOrgCode(val));
Validator.addMessage('type', { orgcode: '请输入有效组织机构代码' });



// WEBPACK FOOTER //
// ./src/utils/validator.js